import { Component, Input, SimpleChanges } from '@angular/core';
import { ModuleManager } from '../../../shared/models/module-manager';
import { ModuleManagerSetting } from '../../../shared/models/module-manager/module-manager-setting.model';
import { DateParadigmDTO } from '../models/date-paradigm.model';
import { CVLocalizationService } from '../services/cv-localization.service';
import { DateParadigmFilterService } from './date-paradigm-filter.service';

@Component({
    selector: 'cv-date-paradigm-filter',
    templateUrl: './date-paradigm-filter.component.html',
    styleUrls: ['./date-paradigm-filter.component.scss']
})
export class DateParadigmFilterComponent {
    @Input() selectedMetrics: number[];
    @Input() moduleManager: ModuleManager;

    // Dropdown variables
    dateParadigmOptions: DateParadigmDTO[] = [] as any;
    selectedOption: DateParadigmDTO = { Name: "null", DisplayName: "", IsDefault: false };
    prevSelectedOption: DateParadigmDTO = { Name: "null", DisplayName: "", IsDefault: false };
    noData = false;

    constructor(
        private dateParadigmFilterService: DateParadigmFilterService,
        private cvLocalizationService: CVLocalizationService, 
    ) { }

    async ngOnInit() {
        await this.cvLocalizationService.GetSection("Date_Paradigm_Filter");
        await this.loadData();
        this.addModuleManagerSetting();
    }

    async loadData() {
        if (this.selectedMetrics?.length > 0) {
            //this.dateParadigmOptions = await this.dateParadigmFilterService.loadDateParadigmData(this.selectedMetrics); commented out for 25.2.2
            if (this.dateParadigmOptions?.length > 0) {
                this.dateParadigmOptions = this.dateParadigmOptions.map(option => ({ ...option, DisplayName: this.cvLocalizationService.getCachedText("Date_Paradigm_Filter", option.Name, option.Name) }));
            } else {
                this.noData = true;
            }
        }
    }

    addModuleManagerSetting() {
        this.moduleManager.registerEvents({
            onSettingsOpened: this.onSettingsOpened.bind(this),
            onSettingsCancelled: this.onSettingsCancelled.bind(this),
        });

        this.moduleManager.addSetting({
            name: 'dateParadigmName',
            required: true,
            getValue: () => this.selectedOption.Name,
            onSettingLoaded: (value) => {
                if (this.dateParadigmOptions.length > 0) {
                    if (value === "null")
                        this.selectedOption = this.dateParadigmOptions.find(option => option.IsDefault === true);
                    else
                        this.selectedOption = this.dateParadigmOptions.find(option => option.Name === value);
                } else {
                    this.selectedOption.Name = value;
                }
            },
            defaultValue: "null"
        } as ModuleManagerSetting<string>);
        this.moduleManager.customSettingsAdded = true;
    }

    onSettingsOpened() {
        this.prevSelectedOption = this.selectedOption;
    }

    onSettingsCancelled() {
        this.selectedOption = this.prevSelectedOption;
    }

    selectedOptionChanged(event: any) {
        this.selectedOption = event.selected;
    }
}
